import { render, staticRenderFns } from "./DialogSyochinaiyou.vue?vue&type=template&id=e4270cbc&scoped=true"
import script from "./DialogSyochinaiyou.vue?vue&type=script&lang=js"
export * from "./DialogSyochinaiyou.vue?vue&type=script&lang=js"
import style0 from "./DialogSyochinaiyou.vue?vue&type=style&index=0&id=e4270cbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4270cbc",
  null
  
)

export default component.exports